<!-- removed content from class "panel-collapse collapse in. Slows performance of collapse -->

<template>
  <v-container fluid class="ma-0 pa-0 px-4 font-weight-medium" style="font-size:14px;">
  <v-card class="pa-2">
    <v-toolbar flat color="white">
      <v-toolbar-title class="pa-0 ma-0">Quick Information</v-toolbar-title>
    </v-toolbar>
    <iframe
      width="100%"
      height="350"
      frameborder="0"
      style="border:0"
      v-bind:src="getgooglemap(companyAddress.company_street,companyAddress.company_city,companyAddress.company_state,companyAddress.company_zip)"
      allowfullscreen
    ></iframe>

    <!--card for company info-->
      <v-layout row wrap>
        <v-flex xs2 md2>
          <v-icon color="indigo">business</v-icon>
        </v-flex>
        <v-flex xs10 md10>
          <div class="caption grey--text">Company Legal Name</div>
          <div class="font-weight-medium">{{company.company_name}}</div>
        </v-flex>
        <v-flex xs2 md2></v-flex>
        <v-flex xs10 md10>
          <div class="caption grey--text">DBA</div>
          <div class="font-weight-medium">{{company.company_dba}}</div>
        </v-flex>
        <v-flex xs12 md12>
          <v-divider inset class="py-2"></v-divider>
        </v-flex>
        <v-flex xs2 md2>
          <v-icon color="indigo">date_range</v-icon>
        </v-flex>
        <v-flex xs4 md4>
          <div class="caption grey--text">Industry Type</div>
          <div>{{company.company_industry}}</div>
        </v-flex>
        <v-flex xs3 md3 style="height: 40px;">
          <div class="caption grey--text">Start Date</div>
          <div>{{formatDate(company.company_started_date)}}</div>
        </v-flex>
        <v-flex xs3 md3>
          <div class="caption grey--text">Time in Biz</div>
          <div v-if="timeBusiness < 1" style="color:red;">{{timeBusiness}} year(s)</div>
          <div
            v-else-if="timeBusiness >= 1 & timeBusiness <= 3 "
            style="color:DarkOrange;"
          >{{timeBusiness}} year(s)</div>
          <div v-else-if="timeBusiness > 3" style="color:green;">{{timeBusiness}} year(s)</div>
        </v-flex>
        <v-flex xs12 md12>
          <v-divider inset class="py-2"></v-divider>
        </v-flex>
        <v-flex xs2 md2>
          <v-icon color="indigo">location_on</v-icon>
        </v-flex>

        <v-flex xs10 md10>
          <div class="caption grey--text">Company Address</div>
          <div>{{companyAddress.company_street}},&nbsp;{{companyAddress.company_city}},&nbsp;{{companyAddress.company_state}}&nbsp;{{companyAddress.company_zip}}</div>
        </v-flex>
        <v-flex xs12 md12>
          <v-divider class="py-2"></v-divider>
        </v-flex>
      </v-layout>
      
    <!--loop for merchant info-->
      <v-layout row wrap v-for="(item, i) in companyMerchants" :key="i">
        <v-flex xs2 md2>
          <v-icon color="indigo">account_box</v-icon>
        </v-flex>
        <v-flex xs10 md10>
          <div class="caption grey--text">Merchant</div>
          <div>{{companyMerchants[i].merchant_first_name}}&nbsp;{{companyMerchants[i].merchant_last_name}}</div>
        </v-flex>
        <v-flex xs12 md12 class="my-1"></v-flex>
        <v-flex xs2 md2>
          <v-icon color="indigo">credit_card</v-icon>
        </v-flex>
        <v-flex xs5 md5>
          <div class="caption grey--text" >Credit Score</div>
          <div >{{companyMerchants[i].merchant_credit_score}}</div>
        </v-flex>
        <v-flex xs5 md5>
          <div class="caption grey--text">Owership</div>
          <div>{{companyMerchants[i].percentage_of_ownership}}%</div>
        </v-flex>
        <v-flex xs12 md12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import fcs_helper from '../../helpers/fcs_helper';
import moment from 'moment'
export default {
    mixins: [fcs_helper],
    methods: {
        formatDate(date){
            return moment(date, 'MMYYYY').format('MM/YYYY')
        }
    }
}
</script>
<style scroped>
.form-group {
  margin-bottom: auto;
}

.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.custom.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
</style>
